// Max screen width for rendering different types of displays (in pixels)
export const MOBILE_MAX_WIDTH = 425;
export const TABLET_MAX_WIDTH = 768;
